import { useCurrentUser as useCurrentUserBase } from "@retro-ia/shared/auth";
import { useUsuarioInfo } from "@retro-ia/shared/hooks";

export const useCurrentUser = () => {
  const base = useCurrentUserBase();
  const { data: usuarioInfo, isLoading: loadingUsuarioInfo } = useUsuarioInfo(
    base.user?.id ?? 0
  );

  return {
    ...base,
    usuarioInfo,
    loadingUsuarioInfo,
  };
};
